import {TextInput} from '../../TextInput/TextInput';
import {useFieldProps} from '../hooks/useFieldProps';
import {TextRendererResponseBody} from '../types/modelSchema';

export function TextRenderer(props: TextRendererResponseBody) {
  const {name, tooltip} = props;
  const {onChange, onBlur, onFocus, value, error, isRequired} = useFieldProps(props);

  return (
    <TextInput
      label={props.label}
      placeholder={props.placeholder}
      data-testid={name}
      onChange={onChange}
      tooltip={tooltip}
      onFocus={onFocus}
      onBlur={onBlur}
      isRequired={isRequired}
      isRecommended={props.isRecommended}
      errorMessage={error?.message}
      value={value || ''}
      isDisabled={props.isReadOnly}
    />
  );
}
